/*
 * Created by TUTEHUB.
 * Copyright © TUTEHUB. All rights reserved.
 * ------------------------
 * Non-disclosure Terms
 * ------------------------
 * These codes are TUTEHUB's property, as the developer, such as employee, contractor, and intern, working for TUTEHUB cannot disclose, spread, copy, preserve, sell, and do other activities without the consent of TUTEHUB.
 * Technique Support: jobyme88.com
 */

import React, {useState} from 'react'
import './commonQuestions.scss'
import { qnaQuestion } from './data'
import {AiOutlineRight, AiOutlineDown} from 'react-icons/ai'

export default function CommonQuestions() {
    const [showAns, setShowAns] = useState("")

 return (
    <div id="mn-common-questions">
        <div className='common-questions-panel'>
            <div className='title p-2'>
                Common Questions
            </div>
            <div className='questions px-5 py-3'>
                <div className="mb-3 px-5 py-3">
                    <h5><b>Help(Q&A)</b></h5>
                </div>
                <div className='body'>
                    <ul className='qna-list'>
                        {qnaQuestion.map(q =>{
                            return(
                                <li className='questions-list' key={q.id}>
                                    <b>{q.ques}</b>
                                    {q.ans.id !== showAns &&
                                        <button className="show-ans" onClick={() =>{setShowAns(q.id)}}>
                                        <AiOutlineRight />
                                        </button>
                                    }
                                    {q.ans.id === showAns && 
                                    <>
                                        <button className="show-ans" onClick={() =>{setShowAns("")}}>
                                        <AiOutlineDown />
                                        </button>
                                    
                                        <div className="ans-list">{q.ans.content}</div>
                                    </>
                                    }
                                    
                                </li>
                            )
                        })}
                    </ul>
                </div>
            </div>
        </div>
    </div>
  )
}
